import type { ReactElement } from 'react';
import { LANGUAGES, activeLanguage, type Language } from './language';

/**
 * The two languages, as the control a person picks one with. `onChoose` saves the choice
 * to their account and then shows the app in it. Each name is written in its own
 * language, so it is never translated.
 */
export function LanguageChoice({
  onChoose,
}: Readonly<{ onChoose: (language: Language) => void }>): ReactElement {
  const active = activeLanguage();
  return (
    <fieldset
      aria-label="Language"
      style={{ border: 'none', margin: 0, padding: 0, display: 'inline-flex', gap: 4 }}
    >
      {LANGUAGES.map(({ code, name }) => (
        <button
          key={code}
          type="button"
          lang={code}
          translate="no"
          aria-pressed={code === active}
          onClick={() => {
            if (code !== active) onChoose(code);
          }}
          style={{
            border: '1px solid currentColor',
            borderRadius: 999,
            padding: '2px 10px',
            fontSize: 12,
            lineHeight: 1.6,
            cursor: code === active ? 'default' : 'pointer',
            background: 'transparent',
            color: 'inherit',
            opacity: code === active ? 1 : 0.55,
            fontWeight: code === active ? 600 : 400,
          }}
        >
          {name}
        </button>
      ))}
    </fieldset>
  );
}
